import React from "react";

export default function SQL_ADD() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQL_ADD</h1>
      <p>This is the SQL_ADD component generated from the SQL JSON.</p>
    </div>
  );
}
